module.exports = __webpack_public_path__ + "static/img/app-store-phone@2x.482125a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-of-the-day/images/app-store-phone@2x.png
// module id = bJCX
// module chunks = 26